import { ClientAssignmentResponse } from '../../../../web-api-client';
import { ClientAssignment } from '../../models';

export const mapClientAssignmentFromResponse = (
  response: ClientAssignmentResponse
): ClientAssignment => ({
  clientAssignmentId: response.clientAssignmentId!,
  clientId: response.clientId!,
  userId: response.userId!,
  isActive: response.isActive!,
});
